var React = require('react');

function TimeFilled (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M24 48c13.255 0 24-10.745 24-24S37.255 0 24 0 0 10.745 0 24s10.745 24 24 24zm.5-31a1.5 1.5 0 00-3 0v8.621l10.44 10.44a1.5 1.5 0 002.12-2.122l-9.56-9.56V17z"}));
}

TimeFilled.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = TimeFilled;

TimeFilled.default = TimeFilled;
